if (!customElements.get('added-notification')) {
  const AddedNotification = class extends HTMLElement {
    connectedCallback() {
      // InvisiBra: on mobile the toast is a bottom sheet, so it lives on <body>, not inside the sticky header
      // (main.js appends it there). Moving it reconnects it, and the second call carries on.
      if (this.isSheet() && this.parentElement !== document.body) {
        document.body.appendChild(this);
        return;
      }
      if (this.ibShown) return;
      this.ibShown = true;
      this.dismissOthers();
      this.setProductTitle(this.dataset.productTitle);
      this.showItem(this.ibItem);
      this.display();
      this.showFreeDelivery();
    }

    disconnectedCallback() {
      clearTimeout(this.delayedDismissTimeout);
    }

    isSheet() {
      return window.matchMedia('(max-width: 767.98px)').matches;
    }

    dismissOthers() {
      document.querySelectorAll('.added-notification').forEach((notification) => {
        if (notification !== this) {
          notification.dismiss();
        }
      });
    }

    setProductTitle(productTitle) {
      this.querySelector('.added-notification__message-title').innerText = productTitle;
    }

    /*
     * InvisiBra: the line just added, from the /cart/add.js response. Bra sizes read "InvisiBra Size C", never
     * a bare letter (the rule in snippets/cart-item.liquid); "Default Title" and "One Size" are left out.
     */
    showItem(item) {
      if (!item) return;

      const image = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
      if (image) {
        const img = this.querySelector('[data-ib-added-image]');
        const url = new URL(image, window.location.origin);
        url.searchParams.set('width', '192');
        img.src = url.toString();
        this.querySelector('[data-ib-added-media]').hidden = false;
      }

      const isBra = (item.product_type || '').indexOf('Bra') !== -1;
      const parts = (item.options_with_values || [])
        .filter((option) => option.value && option.value !== 'Default Title' && !/^one size$/i.test(option.value))
        .map((option) => {
          const name = option.name.toLowerCase();
          const braSize = name === 'invisibra size' || (isBra && (name === 'size' || name === 'cup size'));
          return braSize ? `InvisiBra Size ${option.value}` : option.value;
        });
      if (parts.length) {
        const variant = this.querySelector('[data-ib-added-variant]');
        variant.textContent = parts.join(' · ');
        variant.hidden = false;
      }

      if (typeof item.final_price === 'number') {
        const price = this.querySelector('[data-ib-added-price]');
        price.textContent = this.formatMoney(item.final_price);
        price.hidden = false;
      }
    }

    formatMoney(cents) {
      const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
      try {
        return new Intl.NumberFormat('en-GB', { style: 'currency', currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    display() {
      // reveal
      setTimeout(() => this.classList.remove('added-notification--hidden'), 10);

      // InvisiBra: dismiss after 10 seconds (was 6), and hold while the pointer or focus is on it (WCAG 2.2.1).
      this.startDismissTimer();
      this.addEventListener('mouseenter', () => clearTimeout(this.delayedDismissTimeout));
      this.addEventListener('mouseleave', () => this.startDismissTimer());
      this.addEventListener('focusin', () => clearTimeout(this.delayedDismissTimeout));
      this.addEventListener('focusout', () => this.startDismissTimer());
      this.addEventListener('keydown', (evt) => {
        if (evt.key === 'Escape') this.dismiss();
      });

      // add events to internal links
      this.querySelector('.added-notification__close').addEventListener('click', this.dismiss.bind(this));
      this.querySelector('.ib-added__keep').addEventListener('click', this.dismiss.bind(this));
      if (theme.settings.cartType === 'drawer') {
        this.querySelectorAll('.ib-added__view').forEach((el) => {
          el.addEventListener('click', (evt) => {
            evt.preventDefault();
            document.querySelector('.js-cart-drawer').open(evt.currentTarget);
            this.dismiss();
          });
        });
      }
    }

    startDismissTimer() {
      clearTimeout(this.delayedDismissTimeout);
      this.delayedDismissTimeout = setTimeout(this.dismiss.bind(this), 10000);
    }

    /*
     * InvisiBra: for UK shoppers (data-ib-threshold is set only for them, from
     * snippets/invisibra-delivery.liquid), say how far the basket now is from free delivery.
     */
    showFreeDelivery() {
      const threshold = Number(this.dataset.ibThreshold || 0);
      const line = this.querySelector('[data-ib-toast-delivery]');
      if (!threshold || !line) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => {
          if (!cart) return;
          const left = Math.max(0, threshold - cart.total_price);
          if (left > 0) {
            const amount = document.createElement('strong');
            amount.textContent = this.formatMoney(left);
            line.replaceChildren("You're ", amount, ' away from free UK delivery.');
          } else {
            line.textContent = 'Your order gets free UK delivery.';
          }
          line.hidden = false;
        })
        .catch(() => {});
    }

    dismiss(evt) {
      if (evt) { evt.preventDefault(); }
      clearTimeout(this.delayedDismissTimeout);
      this.classList.add('added-notification--dismissed');
      setTimeout(this.remove.bind(this), 2000);
    }
  };

  window.customElements.define('added-notification', AddedNotification);
}
